module.exports = __webpack_public_path__ + "img/1-2.7b5cfb1f.svg";